import { createSlice } from "@reduxjs/toolkit";

export const name = "mailGateway";

export const mailGatewaySlice = createSlice({
  name,
  initialState: {
    distinctHosts: [],
    distinctHostsLoading: false,
    distinctLiveHosts: [],
    distinctLiveHostsLoading: false,
    analyzedEmails: [],
    analyzedEmailsSubmissions: [],
    analyzedEmailsLoading: false,
    blockedEmails: [],
    blockedEmailsSubmissions: [],
    blockedEmailsLoading: false,
    unblockedEmails: [],
    unblockedEmailsSubmissions: [],
    unblockedEmailsLoading: false,
    releaseEmailId: "",
    releaseEmailLoading: false,
    mailTransferSettings: {},
    mailTransferSettingsLoading: false,
    whitelistSettings: [],
    whitelistSettingsLoading: false,
    blacklistSettings: [],
    blacklistSettingsLoading: false,
    aptAnalysisStatus: {},
    aptAnalysisStatusLoading: false,
    dashboardInsights: {},
    dashboardInsightsLoading: false,
    transferLogs: [],
    transferLogsLoading: false,
    transferLogsPageCount: 0,
    transferLogsTotal: 0,
    transferLogsStatusCounts: {},
    transferLogsTruncated: false,
    urlSettings: {},
    urlSettingsLoading: false,
    setUrlSettingsLoading: false,
    url2Settings: {},
    url2SettingsLoading: false,
    setUrl2SettingsLoading: false,
    sandboxSettings: {},
    sandboxSettingsLoading: false,
    setSandboxSettingsLoading: false,
    spamSettings: {},
    spamSettingsLoading: false,
    setSpamSettingsLoading: false,
    emailNotificationSettings: {},
    emailNotificationSettingsLoading: false,
    setEmailNotificationSettingsLoading: false,
    resetSettingsLoading: false,
    repairSettingsLoading: false,
    fileTypeSettings: [],
    fileTypeSettingsLoading: false,
    generalSettings: [],
    getGeneralSettingsLoading: false,
    setGeneralSettingsLoading: false,
    certificateFile: {},
    certificateFileUploaded: false,
    certificateFileLoading: false,
    sendTestEmailLoading: false,
    alertSettings: {},
    alertSettingsLoading: false,
    setAlertSettingsLoading: false,
  },
  reducers: {
    RequestDistinctHosts: (state) => {
      state.distinctHostsLoading = true;
    },
    SuccessDistinctHosts: (state, action) => {
      state.distinctHosts = action.payload;
      state.distinctHostsLoading = false;
    },
    FailureDistinctHosts: (state) => {
      state.distinctHosts = [];
      state.distinctHostsLoading = false;
    },
    RequestDistinctLiveHosts: (state) => {
      state.distinctLiveHostsLoading = true;
    },
    SuccessDistinctLiveHosts: (state, action) => {
      state.distinctLiveHosts = action.payload;
      state.distinctLiveHostsLoading = false;
    },
    FailureDistinctLiveHosts: (state) => {
      state.distinctLiveHosts = [];
      state.distinctLiveHostsLoading = false;
    },
    RequestAnalyzedEmails: (state) => {
      state.analyzedEmailsLoading = true;
    },
    SuccessAnalyzedEmails: (state, action) => {
      const { analyzed_emails, sbox_submissions } = action.payload;
      state.analyzedEmails = analyzed_emails;
      state.analyzedEmailsSubmissions = sbox_submissions;
      state.analyzedEmailsLoading = false;
    },
    FailureAnalyzedEmails: (state) => {
      state.analyzedEmailsLoading = false;
    },
    RequestBlockedEmails: (state) => {
      state.blockedEmailsLoading = true;
    },
    SuccessBlockedEmails: (state, action) => {
      const { blocked_emails, sbox_submissions } = action.payload;
      state.blockedEmails = blocked_emails;
      state.blockedEmailsSubmissions = sbox_submissions;
      state.blockedEmailsLoading = false;
    },
    FailureBlockedEmails: (state) => {
      state.blockedEmailsLoading = false;
    },
    RequestUnblockedEmails: (state) => {
      state.unblockedEmailsLoading = true;
    },
    SuccessUnblockedEmails: (state, action) => {
      const { unblocked_emails, sbox_submissions } = action.payload;
      state.unblockedEmails = unblocked_emails;
      state.unblockedEmailsSubmissions = sbox_submissions;
      state.unblockedEmailsLoading = false;
    },
    FailureUnblockedEmails: (state) => {
      state.unblockedEmailsLoading = false;
    },
    RequestReleaseEmail: (state, action) => {
      state.releaseEmailId = action.payload.emailId;
      state.releaseEmailLoading = true;
    },
    SuccessReleaseEmail: (state) => {
      state.releaseEmailId = "";
      state.releaseEmailLoading = false;
    },
    FailureReleaseEmail: (state) => {
      state.releaseEmailId = "";
      state.releaseEmailLoading = false;
    },
    RequestSetMailTransferSettings: (state) => {
      state.mailTransferSettingsLoading = true;
    },
    SuccessSetMailTransferSettings: (state, action) => {
      state.mailTransferSettings = action.payload;
      state.mailTransferSettingsLoading = false;
    },
    FailureSetMailTransferSettings: (state) => {
      state.mailTransferSettingsLoading = false;
    },
    RequestGetMailTransferSettings: (state) => {
      state.mailTransferSettingsLoading = true;
    },
    SuccessGetMailTransferSettings: (state, action) => {
      state.mailTransferSettings = action.payload;
      state.mailTransferSettingsLoading = false;
    },
    FailureGetMailTransferSettings: (state) => {
      state.mailTransferSettingsLoading = false;
    },
    RequestGetWhitelistSettings: (state) => {
      state.whitelistSettingsLoading = true;
    },
    SuccessGetWhitelistSettings: (state, action) => {
      state.whitelistSettings = action.payload;
      state.whitelistSettingsLoading = false;
    },
    FailureGetWhitelistSettings: (state) => {
      state.whitelistSettingsLoading = false;
    },
    RequestSetWhitelistSettings: (state) => {
      state.whitelistSettingsLoading = true;
    },
    SuccessSetWhitelistSettings: (state) => {
      state.whitelistSettingsLoading = false;
    },
    FailureSetWhitelistSettings: (state) => {
      state.whitelistSettingsLoading = false;
    },
    RequestGetBlacklistSettings: (state) => {
      state.blacklistSettingsLoading = true;
    },
    SuccessGetBlacklistSettings: (state, action) => {
      state.blacklistSettings = action.payload;
      state.blacklistSettingsLoading = false;
    },
    FailureGetBlacklistSettings: (state) => {
      state.blacklistSettingsLoading = false;
    },
    RequestSetBlacklistSettings: (state) => {
      state.blacklistSettingsLoading = true;
    },
    SuccessSetBlacklistSettings: (state) => {
      state.blacklistSettingsLoading = false;
    },
    FailureSetBlacklistSettings: (state) => {
      state.blacklistSettingsLoading = false;
    },
    RequestAptAnalysisStatus: (state) => {
      state.aptAnalysisStatusLoading = true;
    },
    SuccessAptAnalysisStatus: (state, action) => {
      const { blocked_count, unblocked_count, analysed_count, released_count } = action.payload;
      state.aptAnalysisStatus.blocked = blocked_count;
      state.aptAnalysisStatus.unblocked = unblocked_count;
      state.aptAnalysisStatus.analysed = analysed_count;
      state.aptAnalysisStatus.released = released_count;
      state.aptAnalysisStatusLoading = false;
    },
    FailureAptAnalysisStatus: (state) => {
      state.aptAnalysisStatus = {};
      state.aptAnalysisStatusLoading = false;
    },
    RequestDashboardInsights: (state) => {
      state.dashboardInsightsLoading = true;
    },
    SuccessDashboardInsights: (state, action) => {
      state.dashboardInsights = action.payload;
      state.dashboardInsightsLoading = false;
    },
    FailureDashboardInsights: (state) => {
      state.dashboardInsights = {};
      state.dashboardInsightsLoading = false;
    },
    RequestTransferLogs: (state) => {
      state.transferLogsLoading = true;
    },
    SuccessTransferLogs: (state, action) => {
      const { list, page_count, total, status_counts, truncated } = action.payload;
      state.transferLogs = list || [];
      state.transferLogsPageCount = page_count || 0;
      state.transferLogsTotal = total || 0;
      state.transferLogsStatusCounts = status_counts || {};
      state.transferLogsTruncated = Boolean(truncated);
      state.transferLogsLoading = false;
    },
    FailureTransferLogs: (state) => {
      state.transferLogs = [];
      state.transferLogsPageCount = 0;
      state.transferLogsTotal = 0;
      state.transferLogsStatusCounts = {};
      state.transferLogsTruncated = false;
      state.transferLogsLoading = false;
    },
    RequestGetUrlSettings: (state) => {
      state.urlSettingsLoading = true;
    },
    SuccessGetUrlSettings: (state, action) => {
      state.urlSettings = action.payload;
      state.urlSettingsLoading = false;
    },
    FailureGetUrlSettings: (state) => {
      state.urlSettingsLoading = false;
    },
    RequestGetUrl2Settings: (state) => {
      state.url2SettingsLoading = true;
    },
    SuccessGetUrl2Settings: (state, action) => {
      state.url2Settings = action.payload;
      state.url2SettingsLoading = false;
    },
    FailureGetUrl2Settings: (state) => {
      state.url2SettingsLoading = false;
    },
    RequestGetSandboxSettings: (state) => {
      state.sandboxSettingsLoading = true;
    },
    SuccessGetSandboxSettings: (state, action) => {
      state.sandboxSettings = action.payload;
      state.sandboxSettingsLoading = false;
    },
    FailureGetSandboxSettings: (state) => {
      state.sandboxSettingsLoading = false;
    },
    RequestToggleUrlSettings: (state) => {},
    RequestSetUrlSettings: (state) => {
      state.setUrlSettingsLoading = true;
    },
    SuccessSetUrlSettings: (state) => {
      state.setUrlSettingsLoading = false;
    },
    FailureSetUrlSettings: (state) => {
      state.setUrlSettingsLoading = false;
    },
    RequestToggleUrl2Settings: (state) => {},
    RequestSetUrl2Settings: (state) => {
      state.setUrl2SettingsLoading = true;
    },
    SuccessSetUrl2Settings: (state) => {
      state.setUrl2SettingsLoading = false;
    },
    FailureSetUrl2Settings: (state) => {
      state.setUrl2SettingsLoading = false;
    },
    RequestSetSandboxSettings: (state) => {
      state.setSandboxSettingsLoading = true;
    },
    SuccessSetSandboxSettings: (state) => {
      state.setSandboxSettingsLoading = false;
    },
    FailureSetSandboxSettings: (state) => {
      state.setSandboxSettingsLoading = false;
    },
    RequestGetSpamSettings: (state) => {
      state.spamSettingsLoading = true;
    },
    SuccessGetSpamSettings: (state, action) => {
      state.spamSettings = action.payload;
      state.spamSettingsLoading = false;
    },
    FailureGetSpamSettings: (state) => {
      state.spamSettingsLoading = false;
    },
    RequestToggleSpamSettings: (state) => {},
    RequestSetSpamSettings: (state) => {
      state.setSpamSettingsLoading = true;
    },
    SuccessSetSpamSettings: (state) => {
      state.setSpamSettingsLoading = false;
    },
    FailureSetSpamSettings: (state) => {
      state.setSpamSettingsLoading = false;
    },
    RequestGetEmailNotificationSettings: (state) => {
      state.emailNotificationSettingsLoading = true;
    },
    SuccessGetEmailNotificationSettings: (state, action) => {
      state.emailNotificationSettings = action.payload;
      state.emailNotificationSettingsLoading = false;
    },
    FailureGetEmailNotificationSettings: (state) => {
      state.emailNotificationSettingsLoading = false;
    },
    RequestSetEmailNotificationSettings: (state) => {
      state.emailNotificationSettingsLoading = true;
    },
    SuccessSetEmailNotificationSettings: (state) => {
      state.emailNotificationSettingsLoading = false;
    },
    FailureSetEmailNotificationSettings: (state) => {
      state.emailNotificationSettingsLoading = false;
    },
    RequestResetSettings: (state) => {
      state.resetSettingsLoading = true;
    },
    SuccessResetSettings: (state) => {
      state.resetSettingsLoading = false;
    },
    FailureResetSettings: (state) => {
      state.resetSettingsLoading = false;
    },
    RequestRepairSettings: (state) => {
      state.repairSettingsLoading = true;
    },
    SuccessRepairSettings: (state) => {
      state.repairSettingsLoading = false;
    },
    FailureRepairSettings: (state) => {
      state.repairSettingsLoading = false;
    },
    RequestGetFileTypeSettings: (state) => {
      state.fileTypeSettingsLoading = true;
    },
    SuccessGetFileTypeSettings: (state, action) => {
      state.fileTypeSettings = action.payload;
      state.fileTypeSettingsLoading = false;
    },
    FailureGetFileTypeSettings: (state) => {
      state.fileTypeSettingsLoading = false;
    },
    RequestSetFileTypeSettings: (state) => {
      state.fileTypeSettingsLoading = true;
    },
    SuccessSetFileTypeSettings: (state) => {
      state.fileTypeSettingsLoading = false;
    },
    FailureSetFileTypeSettings: (state) => {
      state.fileTypeSettingsLoading = false;
    },
    RequestGetGeneralSettings: (state) => {
      state.getGeneralSettingsLoading = true;
    },
    SuccessGetGeneralSettings: (state, action) => {
      state.generalSettings = action.payload;
      state.getGeneralSettingsLoading = false;
    },
    FailureGetGeneralSettings: (state) => {
      state.getGeneralSettingsLoading = false;
    },
    RequestSetGeneralSettings: (state) => {
      state.setGeneralSettingsLoading = true;
    },
    SuccessSetGeneralSettings: (state) => {
      state.setGeneralSettingsLoading = false;
    },
    FailureSetGeneralSettings: (state) => {
      state.setGeneralSettingsLoading = false;
    },
    RequestGetCertificateFile: (state) => {
      state.certificateFileLoading = true;
    },
    SuccessGetCertificateFile: (state, action) => {
      state.certificateFile = action.payload;
      state.certificateFileLoading = false;
    },
    FailureGetCertificateFile: (state) => {
      state.certificateFileLoading = false;
    },
    RequestSetCertificateFile: (state) => {
      state.certificateFileLoading = true;
    },
    SuccessSetCertificateFile: (state) => {
      state.certificateFileUploaded = true;
      state.certificateFileLoading = false;
    },
    FailureSetCertificateFile: (state) => {
      state.certificateFileUploaded = false;
      state.certificateFileLoading = false;
      state.certificateFile = {};
    },
    RequestGetKeyFile: (state) => {
      state.keyFileLoading = true;
    },
    SuccessGetKeyFile: (state, action) => {
      state.keyFile = action.payload;
      state.keyFileLoading = false;
    },
    FailureGetKeyFile: (state) => {
      state.keyFileLoading = false;
    },
    RequestSetKeyFile: (state) => {
      state.keyFileLoading = true;
    },
    SuccessSetKeyFile: (state) => {
      state.keyFileUploaded = true;
      state.keyFileLoading = false;
    },
    FailureSetKeyFile: (state) => {
      state.keyFileUploaded = false;
      state.keyFileLoading = false;
      state.keyFile = {};
    },
    RequestSendTestEmail: (state) => {
      state.sendTestEmailLoading = true;
    },
    SuccessSendTestEmail: (state) => {
      state.sendTestEmailLoading = false;
    },
    FailureSendTestEmail: (state) => {
      state.sendTestEmailLoading = false;
    },
    RequestGetAlertSettings: (state) => {
      state.alertSettingsLoading = true;
    },
    SuccessGetAlertSettings: (state, action) => {
      state.alertSettings = action.payload;
      state.alertSettingsLoading = false;
    },
    FailureGetAlertSettings: (state) => {
      state.alertSettingsLoading = false;
    },
    RequestSetAlertSettings: (state) => {
      state.setAlertSettingsLoading = true;
    },
    SuccessSetAlertSettings: (state) => {
      state.setAlertSettingsLoading = false;
    },
    FailureSetAlertSettings: (state) => {
      state.setAlertSettingsLoading = false;
    },
    RequestNextHops: (state) => {
      state.mailTransferSettingsLoading = true;
    },
    SuccessNextHops: (state, action) => {
      state.mailTransferSettings = { ...state.mailTransferSettings, rcptDomains: action.payload };
      state.mailTransferSettingsLoading = false;
    },
    FailureNextHops: (state) => {
      state.mailTransferSettingsLoading = false;
    },
  },
});

export default mailGatewaySlice;
